document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".adv-section").forEach(section => {

    const id = section.dataset.sectionId;
    const slider = document.querySelector(`[data-slider-id="${id}"]`);
    const dots = document.querySelectorAll(`[data-dots-id="${id}"] span`);
    const left = document.querySelector(`.adv-arrow.left[data-slider="${id}"]`);
    const right = document.querySelector(`.adv-arrow.right[data-slider="${id}"]`);

    let index = 0;
    const total = slider.children.length;
    const auto = section.dataset.auto === "true";
    const duration = Number(section.dataset.duration) * 1000;

    /* Lazy Load */
    document.querySelectorAll(".lazy-load").forEach(img => {
      const obs = new IntersectionObserver((entries, o) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            img.src = img.dataset.src;
            img.removeAttribute("data-src");
            o.unobserve(img);
          }
        });
      }, { rootMargin: "200px" });
      obs.observe(img);
    });

    /* Show Slide */
    function show(i) {
      slider.style.transform = `translateX(-${i * 100}%)`;
      dots.forEach(d => d.classList.remove("active"));
      dots[i]?.classList.add("active");
    }

    /* Arrows */
    right.addEventListener("click", () => {
      index = (index + 1) % total;
      show(index);
    });

    left.addEventListener("click", () => {
      index = (index - 1 + total) % total;
      show(index);
    });

    /* Dots */
    dots.forEach(dot => {
      dot.addEventListener("click", () => {
        index = Number(dot.dataset.index);
        show(index);
      });
    });

    /* Auto Slide */
    if (auto) {
      setInterval(() => {
        index = (index + 1) % total;
        show(index);
      }, duration);
    }

    /* Swipe */
    let startX = 0;

    slider.addEventListener("touchstart", e => {
      startX = e.touches[0].clientX;
    }, { passive: true });

    slider.addEventListener("touchend", e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        index = diff > 0 ? (index + 1) % total : (index - 1 + total) % total;
      }
      show(index);
    });

    /* INIT */
    show(0);

  });

});
